import React, { useContext, useEffect, useState } from "react"
import * as patientApi from '../../../service/patientApiDev'
import { CurrentUserContext } from "../../../App"
import { RedirectCode400 } from "../../RedirectCode400"
import { useNavigate } from "react-router-dom"
import Checkbox from '../checkbox/Checkbox'
import { HashLoader } from "react-spinners"
import moment from "moment"
import CheckBoxV3 from "../checkboxV3/CheckBoxV3"

export default function ModalRigthToAccessDataV2({ onClose, data, onClickData }) {

    // const {
    //     setIsMessage
    // } = useContext(CurrentUserContext)
    // const navigate = useNavigate()
    // const [loading, setLoading] = useState(false)

    const [everyTime, setEveryTime] = useState(false)
    const [someTime, setSomeTime] = useState(true)


    // const acceptCredentialToken = async (permission_id, accept, every_time, some_time) => {
    //     setLoading(true)
    //     let res = await patientApi.acceptCredentialToken(permission_id, accept, every_time, some_time)
    //     setLoading(false)

    //     if (res) {
    //         if (res['data']['code'] === 200) {
    //             setIsMessage(res['data']['message_th'] || res['data']['message'])
    //             onClose()
    //         } else if (res['data']['code'] === 403) {
    //             navigate(RedirectCode400())
    //         } else {
    //             console.log(res['data']['message_th'] || res['data']['message'])
    //         }
    //     } else {
    //         setIsMessage('เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่')
    //     }
    // }

    const handleChangePermission = (every, some) => {
        // console.log(every, some)
        setEveryTime(every)
        setSomeTime(some)
    }

    // const acceptCredential = (id, accept, every, some) => {
    //     acceptCredentialToken(id, accept, every, some)
    // }

    return (
        <div className="z-40 fixed flex top-0 right-0 w-full h-full justify-center items-center bg-[#0000008f]">
            {/* <HashLoader loading={loading} style={{ display: 'flex', justifyContent: 'center' }} color="#FF9768" /> */}
            <div className="w-[600px] bg-white rounded-md">
                <div className="flex justify-end mt-[10px] mr-[10px]">
                    <img className="w-7 h-7 cursor-pointer" onClick={() => { onClose() }} src={require('../../../asset/icon/close-icon.svg').default}></img>
                </div>
                <div className="-mt-5 p-7">
                    <div className='w-full text-2xl font-bold text-center'>
                        แจ้งเตือนเจ้าหน้าที่เข้าถึงข้อมูล
                    </div>
                    <div className='text-center text-base font-bold'>
                        <div className="text-gray-500">{data['create_date']['time']} {moment(data["create_date"]["date"]).add(543, "years").format("D MMMM YYYY")} </div>
                        <div>มีเจ้าหน้าที่ต้องการเข้าถึงข้อมูลของท่าน</div>
                        <div>{data['doctor']['pname'] + data['doctor']['fname'] + ' ' + data['doctor']['lname']}</div>
                        <div>{data['doctor']['hospital']['hospital_name']}</div>
                    </div>

                    <div className="flex justify-center mb-5">
                        <div className="ring-[#A2B5BC] ring-1 rounded-lg py-4 px-7 m-4 md:w-full">
                            {/* <p className='text-lg md:text-base text-[#000000] underline underline-offset-4'>แบบฟอร์มอนุญาตให้เข้าถึงข้อมูล</p> */}
                            <div className="mt-2">
                                <div className='md:text-sm text-base font-bold indent-4 text-center'>เลือกประเภทการยินยอม<br/>สำหรับอณุญาตให้แพทย์สามารถเข้าถึงข้อมูลผลตรวจของท่าน</div>
                            </div>
                            <div className='items-center gap-5 my-6'>
                                <CheckBoxV3
                                    id={"checkbox1"} value={everyTime}
                                    setValue={(e) => {
                                        if (e) {
                                            handleChangePermission(true, false)
                                        } else {
                                            handleChangePermission(false, true)
                                        }
                                    }}
                                    label={
                                        <p className="text-sm text-[#000000]">
                                            ข้าพเจ้ายินยอมให้แพทย์และเภสัชกรเข้าถึงข้อมูลผลตรวจได้แบบ <span className="text-blue-500">ไม่มีกำหนด</span>  เพื่อประโยชน์ต่อข้าพเจ้าในการป้องกันและรักษาโรค จนกว่าข้าพเจ้าจะยกเลิกการอนุญาต
                                        </p>
                                    }
                                />
                                
                                <CheckBoxV3 id={"checkbox4"} value={someTime}
                                    setValue={(e) => {
                                        if (e) {
                                            handleChangePermission(false, true)
                                        } else {
                                            handleChangePermission(true, false)
                                        }
                                    }}
                                    label={
                                        <p className="text-sm text-[#000000]">
                                            ข้าพเจ้าจะอนุญาตให้แพทย์หรือเภสัชกรท่านนี้ เข้าถึงข้อมูลของข้าพเจ้าได้เป็นเวลา <span className="text-blue-500">24</span> ชั่วโมง
                                        </p>
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', gridGap: 20 }}>
                        <button
                            onClick={() => {
                                // console.log(data['permission_id'], false, false, false)
                                onClickData(data['permission_id'], false, false, false)
                            }}
                            className="px-5 py-2 text-blue-500 bg-white rounded-md border-blue-500 border">
                            ไม่ยินยอม
                        </button>
                        <button
                            onClick={() => {
                                // console.log(data['permission_id'], true, everyTime, someTime)
                                onClickData(data['permission_id'], true, everyTime, someTime)
                            }} className="px-5 py-2 text-white bg-blue-500 rounded-md">
                            ยินยอม
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}